(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.competicio
   * @description
   *
   */
  angular
  .module('neo.home.seasons', [
    'neo.home.seasons.newSeason',
    'neo.home.seasons.season'
  ]);
}());
